import { getAPI, patchAPI, putAPI } from "./Networking";
import { PaginatedAPIResponse } from "../models/NetworkResponse";
import { StockIssueRequest } from "../models/StockIssueRequest/StockIssueRequest";
import { StockIssueRequestFilters } from "../models/StockIssueRequest/StockIssueRequestFilters";

export default class StockIssueRequestAPI {
  getStockIssueRequestById = async (id: number): Promise<StockIssueRequest> => {
    try {
      const response = await getAPI(`/v1/stock-issue-request/id/${id}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getStockIssueRequests = async (
    filters: StockIssueRequestFilters,
  ): Promise<PaginatedAPIResponse<StockIssueRequest>> => {
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, value.toString());
        }
      });
      const response = await getAPI(
        `/v1/stock-issue-request?${params.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  approveStockIssueRequest = async (id: number): Promise<void> => {
    try {
      await patchAPI(`/v1/stock-issue-request/id/${id}/approve`);
    } catch (error) {
      throw error;
    }
  };

  rejectStockIssueRequest = async (
    id: number,
    rejectionReason: string,
  ): Promise<void> => {
    try {
      await patchAPI(`/v1/stock-issue-request/id/${id}/reject`, {
        rejection_reason: rejectionReason,
      });
    } catch (error) {
      throw error;
    }
  };
}
